import '../../../polyfills';
import WebpackerReact from 'webpacker-react';

import { ProducerMoreInfoLink } from '../../../ProducerMoreInfoLink';
import { ProductBucket } from '../../../ProductBucket';

WebpackerReact.setup({
  ProducerMoreInfoLink,
  ProductBucket,
});
